'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.Moment'];
module.exports = angular.module('AVRO.Common.FileSave', dependencies).factory('FileSaveService', require('./services/FileSaveService')).factory('ColumnNameTransformationService', require('./services/ColumnNameTransformationService'));